// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"c2f2214a","152":"c2f2214a","338":"9711f778","716":"ec9b2e70"}[chunkId] + ".chunk.css";
};